import React from "react";
import AuthShell from "./AuthShell";

const LoginPage = () => (
  <AuthShell
    mode="login"
    testIdPrefix="login"
    eyebrow="Benvenuto"
    headline="Sign in to Napoli Rewards"
    subhead={null}
    footer={{
      label: "New here?",
      linkText: "Join Napoli Rewards →",
      to: "/signup",
    }}
  />
);

export default LoginPage;
